/**
 * OVERVIEW is the default tab
 */
enum ACCOUNT_TAB {
  OVERVIEW = 'overview',
  REVIEWS = 'reviews',
  GOALS = 'goals',
  ANALYTICS = 'analytics',
  DOCUMENTS = 'documents',
  DEBUG = 'debug',
  INSTRUCTIONS = 'requirements',
  // Value matches the builder save/footer redirect target (`../requirements-builder`)
  // so submitting/cancelling a builder instruction returns to this tab, mirroring how
  // INSTRUCTIONS ('requirements') pairs with the recommends flow. Dentist/god only.
  NEW_INSTRUCTIONS = 'requirements-builder',
  NOTES = 'notes',
  RECOMMENDS = 'recommends',
  BUILDER = 'builder',
  TASKS = 'tasks',
  HISTORY = 'history',
  // Never shown as a chip (tabsFilter always hides it); reached via the
  // "New bank account" button on the overview's bank accounts panel.
  NEW_BANK_ACCOUNT = 'new-bank-account',
}

export default ACCOUNT_TAB;
